import { UserLoginClientFirstDto } from '@lucidlink/dto/web-service-api';
import { generateClientFirstMessage } from '@lucidlink/ts-crypto/scram';
export const prepareClientFirst = (email) => {
    const clientFirstMessage = generateClientFirstMessage(email);
    return UserLoginClientFirstDto.create(clientFirstMessage);
};
